import { defineComponent, ref } from 'vue';
import { ElScrollbar } from 'element-plus';
export default defineComponent({
    emits: ['click'],
    props: {
        title: {
            type: String,
            default: ''
        },
        list: {
            type: Array,
            default: () => []
        },
        active: {
            type: String,
            default: ''
        },
        width: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: ''
        }
    },
    components: {
        ElScrollbar
    },
    setup(props, { emit }) {
        const expand = ref(false);
        const labelRef = ref();
        const listRef = ref();
        const pageNameRef = ref();
        const selectRef = ref();
        const selectImgRef = ref();
        const select = () => {
            if (!expand.value && labelRef.value && listRef.value) {
                listRef.value.style.top = `${labelRef.value.clientHeight + 5}px`;
            }
            expand.value = !expand.value;
        };
        const clickItem = (item) => {
            emit('click', item.value);
        };
        document.body.addEventListener('click', (event) => {
            if (event.target !== selectRef.value
                && event.target !== selectImgRef.value && event.target !== pageNameRef.value) {
                expand.value = false;
            }
        });
        return {
            expand,
            labelRef,
            listRef,
            pageNameRef,
            selectRef,
            selectImgRef,
            select,
            clickItem
        };
    }
});
